import { hash } from "rsvp";
import { service } from "@ember/service";
import Route from "@ember/routing/route";
import { restartableTask, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";

export default class LoadBalancerRoute extends Route {
  @service ajax;
  @service store;

  model(params) {
    let { project } = this.modelFor("organization");

    return project.get("loadBalancers").then((loadBalancers) => {
      let loadBalancer = loadBalancers.find((loadBalancer) => loadBalancer.id === params.load_balancer_id);

      return hash({
        project,
        loadBalancer,
        certificates: loadBalancer.get("certificates"),
        servers: project.get("servers"),
      });
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    let { loadBalancer } = model;
    this.targetStatusLoopTask.perform(loadBalancer);
  }

  resetController() {
    super.resetController(...arguments);
    this.targetStatusLoopTask.cancelAll();
  }

  targetStatusLoopTask = restartableTask(async (loadBalancer) => {
    try {
      while (true) {
        let { loadbalancer } = await this.ajax.request(
          `${ENV.apiBaseUri}/loadbalancer/details?loadbalancerid=${loadBalancer.id}`,
        );

        if (!loadBalancer.hasDirtyListeners) {
          let loadBalancerTargets = loadbalancer.backends.flatMap((backend) =>
            backend.targets.map((target) => ({ ...target, id: `${loadBalancer.id}_${target.name}` })),
          );
          this.store.pushPayload({ loadBalancerTargets });
        }

        /* istanbul ignore else */
        if (ENV.environment === "test") {
          return;
        }

        /* istanbul ignore next */
        await timeout(5 * 1000);
      }
    } catch (error) {
      if (loadBalancer.isDeleted) {
        return;
      }

      throw error;
    }
  });
}
